import React, {useMemo} from "react";
import {DuplicatedComponent, FormComponentProps} from "../DynamicFormTypes.ts";
import {renderComponent} from "../dyanimcFormUtil.tsx";


const DuplicatedRenderer: React.FC<FormComponentProps<DuplicatedComponent>> = ({ component }) => {

    const duplicatedComponent = useMemo(() => {
        return renderComponent({
            component: {...component.duplicated, compactUI: component.compactUI},
            prefix: component.fieldKey,
        });
    }, [component.fieldKey, component.compactUI])

    return <>
        {duplicatedComponent}
    </>
}

export const Duplicated = React.memo(DuplicatedRenderer);